import React, { Component } from "react";
import { connect } from "react-redux";
import HomeSliderItem from '../components/HomeSliderItem';
import { getActiveSliderItems } from "../actions/sliderActions"


class HomeSlider extends Component {
  initSlider() {

    const { sliderItems } = this.props;
    if (!sliderItems || sliderItems.items.length === 0) return;

    const $ = window.$;
    const $productCarousel = $(this.refs.productCarousel);
    $productCarousel.owlCarousel({
      items: 1,
      loop: true,
      dots: true,
      autoplay: true,
      autoplayTimeout: 5000,
      nav: true,
      navText: [
        "<i class='fa fa-chevron-left'></i>",
        "<i class='fa fa-chevron-right'></i>"
      ]
    });
  }
     
  componentDidMount() {
    //const { sliderItems } = this.props;
   // if (!sliderItems || sliderItems.items.length === 0) {
      this.props.getActiveSliderItems().then((response) => {
          this.initSlider();
      }, (error) => {
          console.log(error);
      });
    //}
    
  }
  componentDidUpdate() {
    this.initSlider();
  }
  render() {
    const { sliderItems, settings } = this.props;
    if (!sliderItems || sliderItems.items.length === 0) return <div />;
      const sliderItemsList = sliderItems.items.map(sliderItem => (
          <HomeSliderItem key={sliderItem.id} sliderItem={sliderItem} settings={settings} />
    ));

    return (
      <section className="hero-slider hero-slider-background">
        <div
          ref="productCarousel"
          className="owl-carousel large-controls dots-inside"
          data-owl-carousel="{ &quot;nav&quot;: true, &quot;dots&quot;: true, &quot;loop&quot;: true, &quot;autoplay&quot;: true, &quot;autoplayTimeout&quot;: 7000 }"
        >
          {sliderItemsList}
        </div>
      </section>
    );
  }
}
function mapStateToProps({ sliderItems, settings }, ownProps) {
  return { sliderItems, settings, ...ownProps };
}
export default connect(mapStateToProps, { getActiveSliderItems }, null, { forwardRef: true })(HomeSlider);
